<template>
    <div
        id="basicUpload"
        :class="{ hide_load: selectList.length >= bindUploadOptions.limit }"
    >
        <el-upload v-bind="bindUploadOptions" ref="upload" v-on="$listeners">
            <template v-if="!$scopedSlots.btn">
                <el-button size="small" type="primary">
                    {{ $t('message.comC.uploadFile') }}
                </el-button>
            </template>
            <template v-else>
                <slot name="btn" />
            </template>
            <div slot="file" slot-scope="{ file }">
                <template v-if="handleFileType(file) == 'img'">
                    <div class="relative">
                        <img class="h-80 w-80" :src="file.url" alt="" />
                        <div
                            class="absolute position-all-0 modal"
                            @click="handleShowImage(file)"
                        >
                            <div
                                class="delete absolute h-22 text-center bottom-0 left-0 right-0"
                                @click.stop="handleRemove(file)"
                            >
                                <i class="el-icon-delete" />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="handleFileType(file) == 'video'">
                    <div class="relative">
                        <video
                            width="100%"
                            height="80px"
                            :src="file.url"
                            alt=""
                        />
                        <div
                            class="absolute position-all-0 modal"
                            @click="handlePlayVideo(file)"
                        >
                            <div
                                class="delete absolute h-22 text-center bottom-0 left-0 right-0"
                                @click.stop="handleRemove(file)"
                            >
                                <i class="el-icon-delete" />
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="handleFileType(file) == 'file'">
                    <div class="relative">
                        <div class="w-80 h-80 bg-c90959C b-r-8">
                            <img
                                class="h-43 w-43 m-l-18 m-t-18"
                                src="../../assets/common/file.png"
                                alt=""
                            />
                        </div>
                        <div class="absolute position-all-0 modal">
                            <div
                                class="delete absolute h-22 text-center bottom-0 left-0 right-0"
                                @click.stop="handleRemove(file)"
                            >
                                <i class="el-icon-delete" />
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </el-upload>
        <el-dialog
            ref="dialog"
            title=""
            top="35vh"
            append-to-body
            :visible.sync="dialogVisible"
            width="30%"
            @close="handleClose"
        >
            <video :src="videoUrl" controls width="100%" autoplay />
        </el-dialog>
        <el-image-viewer
            v-if="showViewer"
            :on-close="
                () => {
                    showViewer = false;
                    imgList = [];
                }
            "
            style="z-index: 9999"
            :url-list="imgList"
        />
    </div>
</template>

<script>
export default {
    name: 'BasicUpload',
    components: {
        'el-image-viewer': () =>
            import('element-ui/packages/image/src/image-viewer')
    },
    data() {
        return {
            defaultOptions: {
                // default 默认， chat 聊天中的上传
                type: 'default',
                action: '#',
                multiple: false,
                limit: 1,
                'auto-upload': false,
                // accept: '.jpg, .gif, .png',
                'show-file-list': false,
                'on-remove': this.handleOnRemov,
                'before-upload': this.handleBeforeUpload,
                'on-change': this.handleOnChange,
                'on-progress': this.handleOnProgress,
                'on-exceed': this.handleOnExceed,
                fileList: []
            },
            selectList: [],
            videoUrl: '',
            imgList: [],
            dialogVisible: false,
            showViewer: false
        };
    },
    computed: {
        bindUploadOptions() {
            const attrs = {};
            for (const key in this.$attrs) {
                const camelCaseKey = key.replace(/-(\w)/g, (match, p1) =>
                    p1.toUpperCase()
                );
                attrs[camelCaseKey] = this.$attrs[key];
            }
            return {
                ...this.defaultOptions,
                ...attrs
            };
        }
    },
    methods: {
        setOptions(options = {}) {
            this.defaultOptions = {
                ...this.defaultOptions,
                ...options
            };
        },
        handleOnRemove() {
            console.log('handleOnRemove');
        },
        handleOnProgress() {
            console.log('handleOnProgress');
        },
        handleOnChange(file, fileList) {
            this.selectList = fileList;
            if (
                this.bindUploadOptions.limit === 1 &&
                this.bindUploadOptions.type !== 'default'
            ) {
                this.defaultOptions.fileList = [];
            }
            // console.log("handleOnChange");
            // console.log("file", file);
            // console.log("fileList", fileList);
            this.$emit('change', this.selectList);
        },
        // 限制上传，超过50m不让上传
        handleBeforeUpload(file) {
            // console.log("file", file);
            if (file.size > 20 * 1024 * 1024) {
                this.$message.error(this.$t('message.comC.fileSizeLimit'));
                return false;
            }
            return true;
        },
        handleBeforeRemove() {
            console.log('handleBeforeRemove');
        },
        handleOnExceed() {
            console.log('handleOnExceed, 文件达到上限');
        },
        getUploadRef() {
            return this.$refs.upload;
        },
        getFileList() {
            return this.selectList;
        },
        handleRemove(file) {
            // console.log(file, "file");
            // console.log(this.selectList);
            const index = this.selectList.findIndex(v => v.uid === file.uid);
            this.selectList.splice(index, 1);
        },
        handlePlayVideo(file) {
            this.videoUrl = file.url;
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.videoUrl = '';
        },
        handleShowImage(file) {
            this.showViewer = true;
            this.imgList.push(file.url);
        },
        handleFileType(file) {
            const ext = file.name.lastIndexOf('.');
            const fileExt = file.name.slice(ext + 1);
            // console.log("fileExt", fileExt);
            const imageTypeList = ['png', 'gif', 'jpg', 'jpeg'];
            const videoTypeList = ['mp4', 'avi', 'wmv', 'flv'];
            let type = 'img';
            if (imageTypeList.includes(fileExt)) {
                type = 'img';
            } else if (videoTypeList.includes(fileExt)) {
                type = 'video';
            } else {
                type = 'file';
            }
            return type;
        }
    }
};
</script>

<style lang="scss" scoped>
.delete {
    display: none;
}
.modal:hover {
    background-color: rgba(0, 0, 0, 0.2);
    .delete {
        display: block;
        cursor: pointer;
        color: #fff;
        background: rgba(0, 0, 0, 0.45);
        line-height: 22px;
    }
}

::v-deep.el-upload-list--picture-card .el-upload-list__item {
    margin: 0 8px 0 0;
}

::v-deep .el-dialog__close {
    color: #474d57;
    font-weight: bold;
    font-size: 26px;
}

.hide_load {
    ::v-deep .el-upload--picture-card {
        display: none;
    }
}
</style>
